<script lang="ts" setup>
const { code, trustpilotBusinessId } = useI18n().localeProperties.value

const trustpilotContainer = ref<HTMLElement | null>(null)

const loadTrustpilotWidget = () => {
  // Type-safe check with null coalescing
  const tp = window?.Trustpilot
  if (import.meta.client && tp && trustpilotContainer.value) {
    tp.loadFromElement(trustpilotContainer.value)
  }
}

// Lifecycle hooks
onMounted(loadTrustpilotWidget)
onNuxtReady(loadTrustpilotWidget)
</script>

<template>
  <div
    ref="trustpilotContainer"
    class="trustpilot-widget"
    :data-locale="code"
    data-template-id="53aa8807dec7e10d38f59f32"
    :data-businessunit-id="trustpilotBusinessId"
    data-style-height="120px"
    data-style-width="100%"
  />
</template>
